module.exports = __webpack_public_path__ + "da316866ba80df809902845aabd592ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/moos.jpg
// module id = 201
// module chunks = 0